<div class="vtr-widget-about-my-device container-fluid">
	<h3 class="info-title" id="widget-about-my-device-title">{{"dashboard.aboutMyDevice.title" | translate}}
	</h3>
	<div class="row">
		<div class="device-info col-12 col-md-6 col-lg-12 col-xl-6">
			<ul class="info-list">
				<li>
					<span class="info-name" id="widget-about-my-device-serial-number-name"
						role="text">{{"dashboard.aboutMyDevice.serialNumber" | translate}}</span>
					<span class="info-value" id="widget-about-my-device-serial-number-value"
						role="text">{{myDevice.sn}}</span>
					<span class="info-icon" #snCopy id="widget-about-my-device-serial-number-copy" [matTooltip]="'dashboard.aboutMyDevice.copy' | translate"
						matTooltipClass="vtr-system-tooltip"  (click)="copy(myDevice.sn, snCopy)"
						(keydown.enter)="copy(myDevice.sn, snCopy)" tabindex="0" role="button" aria-label="copy" aria-labelledby="widget-about-my-device-serial-number-name widget-about-my-device-serial-number-copy">
						<fa-icon [icon]="['fal', 'copy']"></fa-icon>
					</span>
				</li>
				<li>
					<span class="info-name" id="widget-about-my-device-product-number-name"
						role="text">{{"dashboard.aboutMyDevice.productNumber" | translate}}</span>
					<span class="info-value" id="widget-about-my-device-product-number-value"
						role="text">{{myDevice.productNo}}</span>
				</li>
				<li class="last-item">
					<span class="info-name" id="widget-about-my-device-bios-version-name"
						role="text">{{"dashboard.aboutMyDevice.biosVersion" | translate}}</span>
					<span class="info-value" id="widget-about-my-device-bios-version-value"
						role="text">{{myDevice.bios}}</span>
				</li>
			</ul>
		</div>
		<div class="device-picture col-12 col-md-6 col-lg-12 col-xl-6 order-first order-md-last order-lg-first order-xl-last">
			<div [class]="['brandlogo',brandLogo.logoType]">
				<img [src]="brandLogo.logoPath | svgInline | async" />
			</div>
		</div>
	</div>

</div>